import React, { useState } from 'react';
import { Accordion, Form } from 'react-bootstrap';
import { listTypes } from '../../constants.js';
import i18next from "../../i18n.js";
import { renderDocumentLink } from '../helpers/HelperFunctions.js';

const ItemsForPeriodWidget = (props) => {
    const [checked, setChecked] = useState(props.checked);

    const getLabel = () => {
        switch (props.type) {
            case listTypes.Documents:
                return i18next.t('widgets.itemsForPeriodWidget.myVacations');
            default:
                return '';
        }
    }

    const onCheckChanged = (e) => {
        setChecked(e.target.checked);
        if (props.onCheckChanged) props.onCheckChanged(e.target.checked);
    }

    return <div className={'widget items-for-period ' + props.type}>
        <div key={'for-period-' + props.type}>
            <Form.Check
                type='checkbox'
                label={getLabel()}
                id={'for-period-' + props.type}
                checked={checked}
                onChange={onCheckChanged}
            />
        </div>
        <Accordion>
            <Accordion.Item eventKey='0'>
                <Accordion.Header />
                <Accordion.Body>
                    {props.items?.map(item => renderDocumentLink(item, props.type))}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    </div>
}

export default ItemsForPeriodWidget;